import React from 'react';
import StoerkIdAPI from '../../stoerkID/StoerkIdAPI';
import { useAppSelector } from '../../store.model';
import { getMachineTypeById } from '../selectors/composableDeviceSelectors';

function useMachineTypeById(machineTypeId?: string) {
  const { data, ...rest } =
    StoerkIdAPI.endpoints.getMyWorkspaces.useQuery(undefined);
  const machineType = useAppSelector((state) =>
    getMachineTypeById(state, machineTypeId)
  );
  return { data: machineType, ...rest };
}

export default useMachineTypeById;
